import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appValidateSpecialCharacter]',
    standalone: false
})
export class RegexDirective {

    @HostListener('keypress', ['$event'])
    clickEvent(e: KeyboardEvent) {
        const regex = new RegExp("^[a-zA-Z0-9-.,?!:;'\"//()\\r\\n ]+$");
        if (regex.test(e.key)) {
            return true;
        }
        e.preventDefault()
        return false;
    }
}
